import * as React from 'react'
import { SVGProps } from 'react'

const SvgBellIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <g clipPath='url(#bellIcon_svg__a)' fill='#3071EE'>
      <path d='M10.661 26.5a5.822 5.822 0 0 0 10.678 0H10.66Z' />
      <path
        opacity={0.2}
        d='m28.124 16.64-2.026-6.677a10.874 10.874 0 0 0-21.088.53l-1.573 6.46a5.833 5.833 0 0 0 5.668 7.213H22.54a5.834 5.834 0 0 0 5.583-7.526Z'
      />
    </g>
    <defs>
      <clipPath id='bellIcon_svg__a'>
        <path fill='#fff' transform='translate(2 2)' d='M0 0h28v28H0z' />
      </clipPath>
    </defs>
  </svg>
)

export default SvgBellIcon
